// resources/js/woocommerce/account/index.js
import { mount as mountAccountAddresses } from './account-addresses.js';
import { mount as mountSocialAuth } from './social-auth.js';
import { mount as mountNavToggle } from './nav-toggle.js';

export function mount() {
  mountAccountAddresses?.();
  mountSocialAuth?.();
  mountNavToggle?.();
}
